import { customizationTypesKeys } from 'pages/rule-configuration/components/AddCustomizationModal/view';

const CustomizationType: Record<(typeof customizationTypesKeys)[number], string> = {
  create: 'Create Rule',
  exclude: 'Exclude Variable',
  add: 'Add Values',
  remove: 'Remove Values',
};

export default CustomizationType;
